import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';

import { PageContent } from 'components/page';
import { SVGButton, RestoreButton, DeleteButton } from 'components/widgets/buttons';
import { Table } from 'components/content-containers/tables';
import Person from 'services/data/person';
import SVG from 'components/widgets/icons/svg';
import WorkOrder from 'services/data/work-order';
import classNames from 'classnames';

import * as actions from '../store/actions';


export default function CompanyWorkOrders({ id, currentUser }) {
  const { data: company } = actions.useCompany(id);
  const { data: workOrders, refetch } = actions.useCompanyWorkOrders(id, null, { status: { '!': null } });

  if (!workOrders) return null;

  const update = changes => WorkOrder.update(changes).then(() => refetch());
  const isLead = Person.isLead(currentUser);

  return (
    <PageContent>
      <div>
        {isLead &&
          <Link to={`/companies/${company.id}/work-orders/add`} className="full-page-add-link offset-page-padding btn-success">
            <div>
              <SVG src="svg/add.svg" className="add mr-2" />
              <span>New Work Order</span>
            </div>
            <SVG src="svg/invoice-list.svg" />
          </Link>
        }
        <Table>
          <thead>
            <tr>
              <th className="collapse-width">Work Order</th>
              <th>Description</th>
              <th className="collapse-width text-right">Hours</th>
              <th className="collapse-width text-right"></th>
            </tr>
          </thead>
          <tbody>
            {_.map(workOrders, (workOrder) => {
              const archived = workOrder.status === 'Archived';

              return (
                <tr
                  key={workOrder.id}
                  className={classNames({ 'bg-clouds text-silver': archived })}
                >
                  <td className="collapse-width">{workOrder.number}</td>
                  <td>{workOrder.description}</td>
                  <td className="collapse-width text-right">{workOrder.estimatedHours}</td>
                  <td className="text-right no-padding options-cell">
                    <Link to={`/companies/${company.id}/work-orders/${workOrder.id}/edit`}>
                      <SVGButton src="svg/edit.svg" title="Edit Work Order" />
                    </Link>
                    {!archived &&
                      <DeleteButton
                        title="Archive"
                        onClick={() => update({ status: 'Archived', id: workOrder.id })}
                      />
                    }
                    {archived &&
                      <RestoreButton
                        title="Restore"
                        onClick={() => update({ status: 'Active', id: workOrder.id })}
                      />
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </PageContent>
  );
}



// WEBPACK FOOTER //
// ./app/routes/company/sub-routes/company-work-orders.js